"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = require("@emotion/react");

const classes = {
  root: theme => /*#__PURE__*/(0, _react.css)("flex-grow:1;margin-top:", theme.spacing(2), ";" + (process.env.NODE_ENV === "production" ? "" : ";label:root;"), process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9jb21wb25lbnRlcy9TZWxlY3RvclViaWNhY2lvbkV4YWN0YS9zdHlsZS5qcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFHd0IiLCJmaWxlIjoiLi4vLi4vLi4vc3JjL2NvbXBvbmVudGVzL1NlbGVjdG9yVWJpY2FjaW9uRXhhY3RhL3N0eWxlLmpzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5jb25zdCBjbGFzc2VzID0ge1xuICAgIHJvb3Q6ICh0aGVtZSkgPT4gY3NzYFxuICAgICAgICBmbGV4LWdyb3c6IDE7XG4gICAgICAgIG1hcmdpbi10b3A6ICR7dGhlbWUuc3BhY2luZygyKX07XG4gICAgYCxcbiAgICB0aXRsZToge1xuICAgICAgICBtYXJnaW5Ub3A6IDE1LFxuICAgICAgICBtYXJnaW5Cb3R0b206IDUsXG4gICAgfSxcbiAgICBmb3JtQ29udHJvbDoge1xuICAgICAgICBtYXJnaW5Cb3R0b206IDE1LFxuICAgIH0sXG4gICAgYm9keVRleHQ6IHtcbiAgICAgICAgbWFyZ2luQm90dG9tOiAxNSxcbiAgICB9LFxuICAgIGNvbnRhaW5lck1hcDoge1xuICAgICAgICBoZWlnaHQ6ICc1MHZoJyxcbiAgICAgICAgd2lkdGg6ICcxMDAlJyxcbiAgICAgICAgcG9zaXRpb246ICdyZWxhdGl2ZScsXG4gICAgICAgIG92ZXJmbG93OiAnaGlkZGVuJyxcbiAgICB9LFxuICAgIGNlbnRlck1hcmtlcjoge1xuICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgICAgdG9wOiAnNTAlJyxcbiAgICAgICAgbGVmdDogJzUwJScsXG4gICAgICAgIHpJbmRleDogJzEnLFxuICAgICAgICBtYXJnaW5MZWZ0OiAtMTUsXG4gICAgICAgIG1hcmdpblRvcDogLTMwLFxuICAgICAgICBoZWlnaHQ6IDQxLFxuICAgICAgICB3aWR0aDogMzAsXG4gICAgICAgIGN1cnNvcjogJ3BvaW50ZXInLFxuICAgIH0sXG4gICAgYXJlYU1hcmtlcjoge1xuICAgICAgICBwb3NpdGlvbjogJ2Fic29sdXRlJyxcbiAgICAgICAgZm9udFNpemU6ICc0ZW0nLFxuICAgICAgICBjb2xvcjogJyM0YmJlYzUnLFxuICAgICAgICB6SW5kZXg6IDEsXG4gICAgICAgIGxlZnQ6ICc1MCUnLFxuICAgICAgICB0b3A6ICc1MCUnLFxuICAgICAgICBwb2ludGVyRXZlbnRzOiAnbm9uZScsXG4gICAgfSxcbiAgICBjb250ZW5lZG9yQ2lyY3Vsbzoge1xuICAgICAgICBib3JkZXI6ICcycHggc29saWQgIzRiYmVjNScsXG4gICAgfSxcbiAgICBjaXJjdWxvOiB7XG4gICAgICAgIGJhY2tncm91bmRDb2xvcjogJyM0YmJlYzUnLFxuICAgICAgICBvcGFjaXR5OiAwLjMsXG4gICAgfSxcbn07XG5cbmV4cG9ydCBkZWZhdWx0IGNsYXNzZXM7Il19 */"),
  title: {
    marginTop: 15,
    marginBottom: 5
  },
  formControl: {
    marginBottom: 15
  },
  bodyText: {
    marginBottom: 15
  },
  containerMap: {
    height: '50vh',
    width: '100%',
    position: 'relative',
    overflow: 'hidden'
  },
  centerMarker: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    zIndex: '1',
    marginLeft: -15,
    marginTop: -30,
    height: 41,
    width: 30,
    cursor: 'pointer'
  },
  areaMarker: {
    position: 'absolute',
    fontSize: '4em',
    color: '#4bbec5',
    zIndex: 1,
    left: '50%',
    top: '50%',
    pointerEvents: 'none'
  },
  contenedorCirculo: {
    border: '2px solid #4bbec5'
  },
  circulo: {
    backgroundColor: '#4bbec5',
    opacity: 0.3
  }
};
var _default = classes;
exports.default = _default;